import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function AdminRoute() {
  const { user } = useAuth();
  const isAdmin = ['SUPERUSER', 'ADMIN'].includes(user?.role || '');

  if (!isAdmin) {
    return <Navigate to="/services" replace />;
  }

  return <Outlet />;
}

